import { Component, ViewChild, Input } from '@angular/core';
import { PublishStepper } from '../../context-discovery-services/models/publish-stepper.model';
import { CdtStatus } from '../../app/cdt-status';

@Component({
  selector: 'adminapp-publish-status',
  templateUrl: './publish-status.component.html',
  styleUrls: ['./publish-status.component.scss']
})
export class PublishStatusComponent {

  _completeOnboardingStatus: PublishStepper[];
  _isPublishInProgress: boolean;
  _isPublishFailed: boolean;
  @ViewChild('publishStatusDialog') publishStatusDialog: any;

  constructor() { }

  @Input()
  set completeOnboardingStatus(completeOnboardingStatus: any) {
    if (JSON.stringify(this._completeOnboardingStatus) !== JSON.stringify(completeOnboardingStatus)) {
      this._completeOnboardingStatus = completeOnboardingStatus;
    }
  }

  @Input()
  set isPublishInProgress(publishInProgress: boolean) {
    if (this._isPublishInProgress !== publishInProgress) {
      this._isPublishInProgress = publishInProgress;
    }
  }

  @Input()
  set isPublishFailed(publishFailed: boolean) {
    if (this._isPublishFailed !== publishFailed) {
      this._isPublishFailed = publishFailed;
    }
  }

  open() {
    this.publishStatusDialog.nativeElement.open();
  }

  close() {
    this.publishStatusDialog.nativeElement.close();
  }

  isStatusForPublishFailed(publishStepper: PublishStepper): boolean {
    return (publishStepper.status
      && (publishStepper.status.toUpperCase() === CdtStatus.FAILED
        || publishStepper.status.toUpperCase() === CdtStatus.PUBLISH_FAILED));
  }

  isStatusForPublishSucceeded(publishStepper: PublishStepper): boolean {
    return (publishStepper.status
      && (publishStepper.status.toUpperCase() === CdtStatus.SUCCEEDED
        || publishStepper.status.toUpperCase() === CdtStatus.COMPLETED));
  }

  isStatusForPublishInProgress(publishStepper: PublishStepper): boolean {
    return (publishStepper.status
      && (publishStepper.status.toUpperCase() === CdtStatus.PUBLISH_IN_PROGRESS
        || publishStepper.status.toUpperCase() === CdtStatus.RUNNING));
  }

  isStatusForPublishUnknown(publishStepper: PublishStepper): boolean {
    return (!publishStepper || !publishStepper.status ||
      (!this.isStatusForPublishFailed(publishStepper) && !this.isStatusForPublishSucceeded(publishStepper)
        && !this.isStatusForPublishInProgress(publishStepper)));
  }

  getDisplayLabelForPublishStepper(publishStepper: PublishStepper) {
    return publishStepper.label;
  }

  isPublishToSentienceRequired() {
    if (this._completeOnboardingStatus) {
      return (this._completeOnboardingStatus[0].hasOwnProperty('isPublished')
        && this._completeOnboardingStatus[0]['isPublished'] === false);
    }

    return false;
  }
}
